<template>
  <table :class="className">
    <thead v-if="type === 'date'">
      <tr>
        <th
          v-for="(name, i) in _dayNames"
          :key="i"
        >
          {{ name }}
        </th>
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, i) in data"
        :key="i"
      >
        <template v-for="(col, j) in row">
          <ten-date-item
            v-bind="col"
            :key="j"
            :on-click="onItemClick"
            :on-mouse-enter="onItemMouseEnter"
          >
            <slot v-bind="{ ...col }" />
          </ten-date-item>
        </template>
      </tr>
    </tbody>
  </table>
</template>

<script>
import TenDateItem from './item';

const DAY_NAMES = ['日', '一', '二', '三', '四', '五', '六'];

export default {
  components: {
    TenDateItem,
  },
  props: {
    type: {
      type: String,
      default: 'day',
    },
    /**
     * 一个二维数组
     */
    data: Array,
    /**
     * 周起始日，与Date.prototype.getDay()对应
     */
    firstDayOfWeek: Number,
    /**
     * 星期的显示名字，规定从星期日开始，实际显示顺序会根据 firstDayOfWeek 进行计算
     */
    dayNames: { type: Array, default: () => DAY_NAMES },
    onItemClick: Function,
    onItemMouseEnter: Function,
  },
  computed: {
    className() {
      return `ten-date-${this.type}`;
    },
    _dayNames() {
      const weekArr = [];
      let wi = this.firstDayOfWeek;
      const len = this.dayNames.length;
      while (weekArr.length < len) {
        weekArr.push(this.dayNames[wi]);
        wi = (wi + len + 1) % len;
      }
      return weekArr;
    },
  },
};
</script>
